import {styled, Typography} from "@mui/material";

const TextCardDescription = styled(Typography)`
  font-family: Helvetica, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #666666;
  text-align: center;
`;

export default TextCardDescription;
